export default {
    m000001: '請輸入您當前使用的6位數字交易密碼以驗證身份',
    m000002: '請輸入交易密碼',
    m000003: '忘記交易密碼',
    m000004: '請設置交易密碼',
    m000005: '交易密碼',
    m000006: '確認交易密碼',
    m000007: '密碼長度為6位',
    m000008: '密碼為數字',
    m000009: '兩次輸入的新密碼要一致',
    m000010: '如遇問題，請',
    m000011: '聯繫客服',
    m000012: '提示：可通過訪問我的-安全中心頁面，管理您的交易驗證方式',
    m000013: '交易密碼設置成功',
    m000014: '請輸入交易密碼',
    m000015: '請輸入6位數字交易密碼',
    m000016: '請再次輸入交易密碼',
    m000017: '兩次輸入的密碼不一致',
    m000018: '請輸入您開戶時提交的身份信息以驗證身份',
    m000019: '證件號碼',
    m000020: '郵箱',
    m000021: '請輸入證件號碼',
    m000022: '請輸入郵箱',
    m000023: '重置成功!',
    m000024: '在線客服',
    m000025: '提示：請提前安裝微信，並登錄',
    m000026: '客服熱線',
    m000027: '客服郵箱',
    m000028: '關閉',
    m000029: '遇到問題',
    m000030: '忘記登錄密碼',
    m000031: '聯繫客服',
    m000032: '修改成功!',
    m000033: '修改交易密碼',
    m000034: '重置交易密碼',
    m000035: '確定',
    m000036: '去設置',
    m000037: '稍後',
    m000038: '身份地址',
    m000039: '居住地址',
}